export default "__VITE_ASSET__DkpetMxW__"